import { ReactNode } from 'react'
import * as yup from 'yup'
import { Form } from '@/ui'

export const QuestionRow = ({
  label,
  popupContent,
  name,
  schema,
}: {
  label: string
  popupContent?: ReactNode
  name: string
  schema?: yup.StringSchema<string | null | undefined>
}) => (
  <div className="flex flex-col">
    <Form.Field
      name={name}
      schema={schema}
      label={label}
      popupContent={popupContent}
    />

    <div className="flex gap-2 mt-4">
      <Form.Toggle
        name={name}
        value="true"
        deselectValue=""
        variant="outline"
        size="lg"
        className="min-w-[72px]"
      >
        Yes
      </Form.Toggle>
      <Form.Toggle
        name={name}
        value="false"
        deselectValue=""
        variant="outline"
        size="lg"
        className="min-w-[72px]"
      >
        No
      </Form.Toggle>
    </div>
  </div>
)
